module.exports = __webpack_public_path__ + "static/media/yom_logo.54c2cbd7.png";